import { createFileRoute } from '@tanstack/react-router';
import { AutomationIndexRouteView } from '@/pages/workspaces/automations/[campaignId]/overview/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/$campaignId/')({
  component: AutomationIndexRouteView,
});
